var map = {
	".": 33871,
	"./": 33871,
	"./ClaimDetails": 62027,
	"./ClaimDetails/": 62027,
	"./ClaimDetails/Component": 39831,
	"./ClaimDetails/Component.tsx": 39831,
	"./ClaimDetails/index": 62027,
	"./ClaimDetails/index.ts": 62027,
	"./Component": 74691,
	"./Component.tsx": 74691,
	"./LinkOpened": 53928,
	"./LinkOpened/": 53928,
	"./LinkOpened/Component": 84546,
	"./LinkOpened/Component.tsx": 84546,
	"./LinkOpened/index": 53928,
	"./LinkOpened/index.ts": 53928,
	"./PhotosUploaded": 40284,
	"./PhotosUploaded/": 40284,
	"./PhotosUploaded/Component": 61289,
	"./PhotosUploaded/Component.tsx": 61289,
	"./PhotosUploaded/index": 40284,
	"./PhotosUploaded/index.ts": 40284,
	"./WebappLink": 76551,
	"./WebappLink/": 76551,
	"./WebappLink/Component": 4533,
	"./WebappLink/Component.tsx": 4533,
	"./WebappLink/index": 76551,
	"./WebappLink/index.ts": 76551,
	"./images/ageas-guide.jpg": 57218,
	"./index": 33871,
	"./index.ts": 33871,
	"./styles": 39794,
	"./styles.ts": 39794,
	"./useSummary": 3603,
	"./useSummary.ts": 3603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72430;